import {
  _isMobile
} from "@/utils"
/**
 * 页面插件：添加按钮点击返回上一页
 */
class goBackPage {
  constructor(vue) {
    this.context = vue
  }
  async init() {
    console.log('点击返回上一页:编辑页展示')
    return
    if(!_isMobile()) return false
    const newDiv1 = document.createElement('style');
    newDiv1.type = 'text/css';
    newDiv1.innerHTML = `
      #gobackPageButton {
        font-size: 34px; 
        position: fixed;
        z-index: 9999;
        top: 10%;
        left: 10%;
        border-radius: 50%;
        color: white;
        background-color: #9E9E9E;
      }
    `;
    const newDiv = document.createElement('div');
    newDiv.innerHTML = '';
    newDiv.id = 'gobackPageButton';
    newDiv.classList = 'icon icon-portal-arrows-left';
    document.getElementById('__nuxt').appendChild(newDiv);
    const head = document.head;
    head.appendChild(newDiv1);
    document.getElementById("gobackPageButton").addEventListener("click", ()=> {
      console.log('点击返回上一页:编辑页不跳转')
      // this.context.$router.go(-1);
    })
  }
}
export default {
  methods: {
    goBackPagePlugin() {
      const goBackPage1 = new goBackPage(this)
      this.goBackPage1 = goBackPage1
      goBackPage1.init()
    },
  },
  beforeDestroy() {
    this.goBackPage1?.removeEventTrigger()
  }
}
